import React, { useState, useRef, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import epl from "../images/epl.png";
import ligue1 from "../images/ligue1.png";
import bundesliga from "../images/bundesliga.png";
import seriea from "../images/seriea.png";
import champions from "../images/championsleague.png";
import laliga from "../images/laliga.png";
import worldCup from "../images/worldcup.svg";
import eflChampionship from "../images/efl_championship.png";
import eflCup from "../images/efl_cup.png";

const nationsLeague = "/images/nationsleague.png";

const LEAGUES = [
  { name: "Premier League", icon: epl, key: "soccer_epl" },
  { name: "EFL Championship", icon: eflChampionship, key: "soccer_efl_champ" },
  { name: "Champions League", icon: champions, key: "soccer_uefa_champs_league" },
  { name: "EFL Cup", icon: eflCup, key: "soccer_england_efl_cup" },
  { name: "La Liga", icon: laliga, key: "soccer_spain_la_liga" },
  { name: "Bundesliga", icon: bundesliga, key: "soccer_germany_bundesliga" },
  { name: "Serie A", icon: seriea, key: "soccer_italy_serie_a" },
  { name: "Ligue 1", icon: ligue1, key: "soccer_france_ligue_one" },
  { name: "FIFA World Cup", icon: worldCup, key: "soccer_fifa_world_cup" },
  { name: "UEFA Nations League", icon: nationsLeague, key: "soccer_uefa_nations_league" },
];

export default function App({selectedLeague, setSelectedLeague}) {

  const scrollContainerRef = useRef(null);
  const mobileSelectorRef = useRef(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);
  const [mobileLeagueMenuOpen, setMobileLeagueMenuOpen] = useState(false);
  // Keep the seasonal league hidden until the backend confirms that its
  // current odds snapshot contains at least one match.
  const [worldCupAvailable, setWorldCupAvailable] = useState(null);

  useEffect(() => {
    let cancelled = false;
    fetch('/api/league-availability')
      .then((response) => response.json())
      .then((availability) => {
        if (cancelled || availability.availability_unknown) return;
        const available = availability.soccer_fifa_world_cup !== false;
        setWorldCupAvailable(available);
        if (!available && selectedLeague.key === 'soccer_fifa_world_cup') {
          setSelectedLeague(LEAGUES[0]);
        }
      })
      .catch((error) => {
        // Keep the last known state when the availability check fails. On the
        // initial request this leaves the seasonal league hidden.
        console.error('Unable to check World Cup availability:', error);
      });

    return () => {
      cancelled = true;
    };
  }, [selectedLeague.key, setSelectedLeague]);

  const visibleLeagues = LEAGUES.filter(
    (league) => league.key !== 'soccer_fifa_world_cup' || worldCupAvailable === true
  );
  const currentLeague = visibleLeagues.find(
    (league) => league.key === selectedLeague.key
  ) || selectedLeague;

  const checkScrollability = () => {
    const container = scrollContainerRef.current;
    if (container) {
      const { scrollLeft, scrollWidth, clientWidth } = container;
      // console.log(scrollLeft, scrollWidth, clientWidth)
      setCanScrollLeft(scrollLeft > 0);
      setCanScrollRight(scrollLeft < scrollWidth - clientWidth - 1);
    }
  };

  useEffect(() => {
    const container = scrollContainerRef.current;
    checkScrollability();
    container?.addEventListener("scroll", checkScrollability);
    window.addEventListener("resize", checkScrollability);

    return () => {
      container?.removeEventListener("scroll", checkScrollability);
      window.removeEventListener("resize", checkScrollability);
    };
  }, []);

  useEffect(() => {
    if (!mobileLeagueMenuOpen) return undefined;

    const closeOnOutsidePress = (event) => {
      if (!mobileSelectorRef.current?.contains(event.target)) {
        setMobileLeagueMenuOpen(false);
      }
    };
    const closeOnEscape = (event) => {
      if (event.key === 'Escape') setMobileLeagueMenuOpen(false);
    };

    document.addEventListener('pointerdown', closeOnOutsidePress);
    document.addEventListener('keydown', closeOnEscape);
    return () => {
      document.removeEventListener('pointerdown', closeOnOutsidePress);
      document.removeEventListener('keydown', closeOnEscape);
    };
  }, [mobileLeagueMenuOpen]);

  const scroll = (direction) => {
    if (scrollContainerRef.current) {
      const scrollAmount = 70;
      scrollContainerRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  return (
    <div className="league-selector-shell text-white d-flex justify-content-center align-items-center col-lg-10 col-sm-12 m-auto pt-2 pb-1">
      <div className="w-100" >
        <div>
          <div className="league-mobile-selector">
            <div ref={mobileSelectorRef} className="league-mobile-five-layout">
              <button
                type="button"
                className="league-mobile-row-toggle dropdown-toggle"
                aria-expanded={mobileLeagueMenuOpen}
                aria-label={`Choose league. Currently ${currentLeague.name}`}
                onClick={() => setMobileLeagueMenuOpen((isOpen) => !isOpen)}
              >
                <span className="league-mobile-selected-display">
                  <img
                    src={currentLeague.icon}
                    alt=""
                    className="league-mobile-logo"
                    width={28}
                    height={28}
                  />
                  <span>{currentLeague.name}</span>
                </span>
                <svg width="18" height="18" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true">
                  <path d="M3.2 5.7a.75.75 0 0 1 1.06 0L8 9.44l3.74-3.74a.75.75 0 1 1 1.06 1.06l-4.27 4.27a.75.75 0 0 1-1.06 0L3.2 6.76a.75.75 0 0 1 0-1.06Z"/>
                </svg>
              </button>
              <ul className={`league-mobile-menu league-mobile-named-menu ${mobileLeagueMenuOpen ? 'show' : ''}`}>
                {visibleLeagues.map((league) => (
                  <li key={league.key}>
                    <button
                      type="button"
                      className={`league-mobile-option ${
                        selectedLeague.key === league.key ? 'league-mobile-option-selected' : ''
                      }`}
                      onClick={() => {
                        if (selectedLeague.key !== league.key) {
                          setSelectedLeague(league);
                        }
                        setMobileLeagueMenuOpen(false);
                      }}
                    >
                      <img
                        src={league.icon}
                        alt=""
                        className="league-mobile-logo"
                        width={28}
                        height={28}
                        loading="lazy"
                      />
                      <span>{league.name}</span>
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="league-desktop-selector d-flex align-items-center justify-content-between">
            
            {/* Left Side: Selected League */}
            <div className="d-flex align-items-center mt-1 w-70"
            style={{
                flex: "0 0 50%",          // fixed 60% width
                minWidth: 0,              // allows ellipsis to work
            }}>
              <h1 className="text-white"
              style={{ maxWidth: "100%" }}>{selectedLeague.name}</h1>
            </div>

            {/* Right Side: Scrollable Logos */}
            <div
                className="position-relative w-40 d-flex align-items-center overflow-hidden justify-content-end ps-3"
                style={{ flex: "0 0 50%" }}>
                    
                {canScrollLeft && (
                    <button
                    onClick={() => scroll("left")}
                    className="btn btn-chevron btn-chevron-left position-absolute start-0 top-50 translate-middle-y shadow-sm"
                    style={{ zIndex: 10 }}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="white" className="bi bi-chevron-left" viewBox="0 0 16 16">
                            <path fillRule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0"/>
                        </svg>
                    </button>
                )}

                <div
                    ref={scrollContainerRef}
                    className="d-flex overflow-auto py-2"
                    style={{
                    gap: "1rem",
                    scrollbarWidth: "none",
                    msOverflowStyle: "none",
                    maxWidth: "100%", 
                    }}
                >
                    {visibleLeagues.map((league) => {
                      return (
                        <div
                        key={league.key}
                        className="d-flex flex-column align-items-center text-center flex-shrink-0"
                        style={{ width: "40px" , height: "40px"}}
                    >
                        <button
                            key={league.key}
                            onClick={() => {
                              if (selectedLeague.key !== league.key) {
                                setSelectedLeague(league);
                              }
                            }}
                            className={`btn p-0 bg-grey flex-shrink-0 rounded-circle ${
                                selectedLeague.key === league.key
                                ? "border-orange shadow-lg border-3"
                                : "border-grey border-1"
                            }`}
                            style={{
                                transition: "all 0.3s ease",
                            }}
                            title={league.name}
                            aria-label={league.name}
                        >
                            <img
                            src={league.icon}
                            alt={league.name}
                            className="rounded-circle"
                            style={{
                                width: "35px",
                                height: "35px",
                                objectFit: "cover",
                                transition: "all 0.3s ease",
                            }}
                            width = {35} height = {35}
                            loading="lazy"
                            />
                        </button>
                        {/* <small className="text-light mt-1 font-10">
                            {league.name.length > 6 ? league.name.slice(0, 6) + "…" : league.name}
                        </small> */}
                    </div>
                      );
                    })}
                </div>

                {canScrollRight && (
                    <button
                    onClick={() => scroll("right")}
                    className="btn btn-chevron btn-chevron-right position-absolute end-0 top-50 translate-middle-y shadow-sm"
                    style={{ zIndex: 10 }}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="white" className="bi bi-chevron-right" viewBox="0 0 16 16">
                            <path fillRule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"/>
                        </svg>
                    </button>
                )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
